import {defHttp} from '/@/utils/http/axios';
import {
  LoginParams,
  LoginResultModel,
  GetUserInfoModel,
} from './model/userModel';

import {ErrorMessageMode} from '/#/axios';

enum Api {
  Login = '/auth/login',
  Logout = '/auth/logout',
  GetUserInfo = '/WebAccountService/findAccountInfo',
  GetPermCode = '/getPermCode',
  TestRetry = '/testRetry',
}

/**
 * @description:  contentTyp
 */
export enum ContentTypeEnum {
  // json
  JSON = 'application/json;charset=UTF-8',
  // form-data qs
  FORM_URLENCODED = 'application/x-www-form-urlencoded;charset=UTF-8',
  // form-data  upload
  FORM_DATA = 'multipart/form-data;charset=UTF-8',
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  // const isMock = false; // import.meta.env.VITE_USE_MOCK;
  // @ts-ignore
  // const contentType = isMock === 'true' ? ContentTypeEnum.JSON : ContentTypeEnum.FORM_URLENCODED;
  const contentType = ContentTypeEnum.JSON;

  // console.log(isMock, typeof isMock, contentType);
  return defHttp.post<LoginResultModel>(
    {
      url: `${Api.Login}?password=${params.password}&username=${params.username}`,
      headers: {
        'Content-Type': contentType,
      },
    },
    {
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  // return defHttp.get<GetUserInfoModel>({ url: Api.GetUserInfo }, { errorMessageMode: 'none' });
  return defHttp.post<GetUserInfoModel>({url: Api.GetUserInfo});
}

export function getPermCode() {
  return defHttp.get<string[]>({url: Api.GetPermCode});
}

export function doLogout() {
  return defHttp.get({url: Api.Logout});
}

export function testRetry() {
  return defHttp.get(
    {url: Api.TestRetry},
    {
      retryRequest: {
        isOpenRetry: true,
        count: 5,
        waitTime: 1000,
      },
    },
  );
}
